<wj-tab-panel id="tab_SearchResult" #tab_SearchResult forcedEnabledMode="true">

  <wj-tab>
    <a>商品画像</a>
    <div class="frame-solid">
      <div class="element-column">
        <div class="layout_end">
          <div>
            <label id="lbl_GoodsImageCnt" [style.margin-right.px]="4">{{ this.goodsImageCnt}}</label>
            <label [style.margin-right.px]="2">件</label>
          </div>
        </div>

        <div id="hli_GoodsImageList" #hli_GoodsImageList class="frame-solid">
          <ul #goodsImageGroups>
            <li *ngFor="let item of goodsImageList; let i = index;"
              (mousedown)="eventGoodsImageList_ITEMCLICK.emit({event: $event, index: i, goodsImageList: goodsImageList, goodsImageGroups: goodsImageGroups})">
              <app-image-info-renderer5002 [data]="item"></app-image-info-renderer5002>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </wj-tab>

  <wj-tab>
    <a>使用履歴</a>
    <div class="frame-solid">
      <div class="element-column">
        <div class="layout_balance" style="align-items: center;">
          <div class="column-list">
            <label class="list-input-title">Ｐコード</label>
            <div class="list-input-content">
              <select id="cmb_PcodeList" forcedEnabledMode="true" [tabindex]="-1" [(ngModel)]="pCode"
                (change)="eventPcodeList_CHANGE.emit($event)">
                <ng-template ngFor let-item [ngForOf]="pcodeList">
                  <option value="{{item.Pcode}}">{{item.Pcode}}</option>
                </ng-template>
              </select>
            </div>
          </div>

          <div>
            <label id="lbl_UseHitoryImageCnt" [style.margin-right.px]="4">{{useHitoryImageCnt}}</label>
            <label [style.margin-right.px]="2">件</label>
          </div>
        </div>


        <!-- グリッド -->
        <div class="block-row history-container">
          <wj-flex-grid #dgv_PcodeInfoList id="dgv_PcodeInfoList" [itemsSource]="pcodeInfoList" [allowResizing]="true"
            [isReadOnly]="true" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
            [selectionMode]="'Row'" forcedEnabledMode="true">
            <wj-flex-grid-column [minWidth]="5" [header]="'受注コード'" [binding]="'OrderCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'配達企画回(翌週)'" [binding]="'DelivCatalogId'" [width]="274">
            </wj-flex-grid-column>
          </wj-flex-grid>
          <!-- グリッドここまで -->

          <div class="frame-solid" id="hli_UseHistoryImageList" #hli_UseHistoryImageList forcedEnabledMode="true">
            <ul #useHistoryImageGroups>
              <li *ngFor="let item of useHistoryImageList; let i = index;"
                (mousedown)="eventUseHistoryImageList_ITEMCLICK.emit({event: $event, index: i, useHistoryImageList: useHistoryImageList, useHistoryImageGroups: useHistoryImageGroups})">
                <app-image-info-renderer5002 [data]="item"></app-image-info-renderer5002>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </wj-tab>

  <wj-tab>
    <a>検索画像</a>
    <div class="frame-solid">
      <div class="element-column">
        <div class="layout_balance" style="align-items: center;">
          <div>
            <button id="btn_Search" forcedEnabledMode="true" [tabindex]="-1" class="btn-secondary"
              (click)="eventBtnSearch_CLICK.emit()">画像検索</button>
          </div>
          <div>
            <label id="lbl_SearchImageCnt" [style.margin-right.px]="4">{{searchImageCnt}}</label>
            <label [style.margin-right.px]="2">件</label>
          </div>
        </div>

        <div class="frame-solid" id="hli_SearchImageList" #hli_SearchImageList forcedEnabledMode="true">
          <ul #searchImageGroups>
            <li *ngFor="let item of searchImageList; let i = index;"
              (mousedown)="eventSearchImageList_ITEMCLICK.emit({event: $event, index: i, searchImageList: searchImageList, searchImageGroups: searchImageGroups})">
              <app-image-info-renderer5002 [data]="item"></app-image-info-renderer5002>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </wj-tab>
</wj-tab-panel>